import { Vector3 } from "three";

export const GLOBAL_LIGHT_COLOR = 0xffffff;
export const GLOBAL_LIGHT_INTENSITY = 0.7;
export const GLOBAL_LIGHT_POSITION = new Vector3(40, 40, 0);
export const GLOBAL_LIGHT_TARGET = new Vector3(0, 0, 0);

export const AMBIENT_LIGHT_COLOR = 0xffffff;
export const AMBIENT_LIGHT_INTENSITY = 0.3;